import React from 'react';
import { Modal, Button, Result } from 'antd';
import { useServer } from '../../context/ServerContext';
import { CloseCircleOutlined } from '@ant-design/icons';

const ServerErrorModal = () => {
  const { serverError, errorMessage, exitApplication } = useServer();

  const modalStyle = {
    zIndex: 9999,
  };

  return (
    <Modal
      open={serverError}
      closable={false}
      maskClosable={false}
      footer={null}
      style={modalStyle}
      width={500}
      centered
    >
      <Result
        status="error"
        title="Errore di connessione al server"
        subTitle={errorMessage || "Si è verificato un problema nella comunicazione con il server. Riprova più tardi."}
        icon={<CloseCircleOutlined style={{ color: '#ff4d4f' }} />}
        extra={[
          <Button 
            type="primary" 
            key="exit" 
            onClick={exitApplication}
            danger
            size="large"
            style={{ width: '200px' }}
          >
            Esci dall'applicazione
          </Button>,
        ]}
      />
    </Modal>
  );
};

export default ServerErrorModal;